import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const genericTranslationsK = {
  minimalView: "generic_translations.minimalView",
  email: "generic_translations.email",
  selected: "generic_translations.selected",
  saveAndClose: "generic_translations.saveAndClose",
  duplicate: "generic_translations.duplicate",
  pictureStore: "generic_translations.pictureStore",
  copyWithValues: "generic_translations.copyWithValues",
  mobilePhoneNo: "generic_translations.mobilePhoneNo",
  add: "generic_translations.add",
  saveFirst: "generic_translations.saveFirst",
  menu: "generic_translations.menu",
  permission: "generic_translations.permission",
  name: "generic_translations.name",
  actions: "generic_translations.actions",
  mobilePhonePrefix: "generic_translations.mobilePhonePrefix",
  pressTabToAdd: "generic_translations.pressTabToAdd",
  filter: "generic_translations.filter",
  password: "generic_translations.password",
  imagebank: "generic_translations.imagebank",
  selectAll: "generic_translations.selectAll",
  numberOfCopies: "generic_translations.numberOfCopies",
  permissions: "generic_translations.permissions",
  search: "generic_translations.search",
  areYouSure: "generic_translations.areYouSure",
  unsavedChanges: "generic_translations.unsavedChanges",
  reset: "generic_translations.reset",
  noOptionsAvailable: "generic_translations.noOptionsAvailable",
  uploadFileHint: "generic_translations.uploadFileHint",
  apply: "generic_translations.apply",
  print: "generic_translations.print",
  uploadFileRule: "generic_translations.uploadFileRule",
  more: "generic_translations.more",
  back: "generic_translations.back",
  mail: "generic_translations.mail",
  date: "generic_translations.date",
  download: "generic_translations.download",
  copy: "generic_translations.copy",
  selectedFile: "generic_translations.selectedFile",
  searchShortcut: "generic_translations.searchShortcut",
  delete: "generic_translations.delete",
  confirmPassword: "generic_translations.confirmPassword",
  close: "generic_translations.close",
  cancel: "generic_translations.cancel",
  emailAddress: "generic_translations.emailAddress",
  dynamicValue: "generic_translations.dynamicValue",
  clear: "generic_translations.clear",
  open: "generic_translations.open",
  sortAscending: "generic_translations.sortAscending",
  done: "generic_translations.done",
  dekoSupport: "generic_translations.dekoSupport",
  no: "generic_translations.no",
  edit: "generic_translations.edit",
  copyBlank: "generic_translations.copyBlank",
  yes: "generic_translations.yes",
  save: "generic_translations.save",
  sortDescending: "generic_translations.sortDescending",
  next: "generic_translations.next",
  fullView: "generic_translations.fullView",
};

export const useGenericTranslationsT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      minimalView: t(genericTranslationsK.minimalView),
      email: t(genericTranslationsK.email),
      selected: (total: string) => t(genericTranslationsK.selected, { total }),
      saveAndClose: t(genericTranslationsK.saveAndClose),
      duplicate: t(genericTranslationsK.duplicate),
      pictureStore: t(genericTranslationsK.pictureStore),
      copyWithValues: t(genericTranslationsK.copyWithValues),
      mobilePhoneNo: t(genericTranslationsK.mobilePhoneNo),
      add: t(genericTranslationsK.add),
      saveFirst: t(genericTranslationsK.saveFirst),
      menu: t(genericTranslationsK.menu),
      permission: t(genericTranslationsK.permission),
      name: t(genericTranslationsK.name),
      actions: t(genericTranslationsK.actions),
      mobilePhonePrefix: t(genericTranslationsK.mobilePhonePrefix),
      pressTabToAdd: t(genericTranslationsK.pressTabToAdd),
      filter: t(genericTranslationsK.filter),
      password: t(genericTranslationsK.password),
      imagebank: t(genericTranslationsK.imagebank),
      selectAll: t(genericTranslationsK.selectAll),
      numberOfCopies: t(genericTranslationsK.numberOfCopies),
      permissions: t(genericTranslationsK.permissions),
      search: t(genericTranslationsK.search),
      areYouSure: t(genericTranslationsK.areYouSure),
      unsavedChanges: t(genericTranslationsK.unsavedChanges),
      reset: t(genericTranslationsK.reset),
      noOptionsAvailable: t(genericTranslationsK.noOptionsAvailable),
      uploadFileHint: (fileTypes: string) => t(genericTranslationsK.uploadFileHint, { fileTypes }),
      apply: t(genericTranslationsK.apply),
      print: t(genericTranslationsK.print),
      uploadFileRule: (size: string) => t(genericTranslationsK.uploadFileRule, { size }),
      more: t(genericTranslationsK.more),
      back: t(genericTranslationsK.back),
      mail: t(genericTranslationsK.mail),
      date: t(genericTranslationsK.date),
      download: t(genericTranslationsK.download),
      copy: t(genericTranslationsK.copy),
      selectedFile: (fileName: string) => t(genericTranslationsK.selectedFile, { fileName }),
      searchShortcut: t(genericTranslationsK.searchShortcut),
      delete: t(genericTranslationsK.delete),
      confirmPassword: t(genericTranslationsK.confirmPassword),
      close: t(genericTranslationsK.close),
      cancel: t(genericTranslationsK.cancel),
      emailAddress: t(genericTranslationsK.emailAddress),
      dynamicValue: (value: string) => t(genericTranslationsK.dynamicValue, { value }),
      clear: t(genericTranslationsK.clear),
      open: t(genericTranslationsK.open),
      sortAscending: t(genericTranslationsK.sortAscending),
      done: t(genericTranslationsK.done),
      dekoSupport: t(genericTranslationsK.dekoSupport),
      no: t(genericTranslationsK.no),
      edit: t(genericTranslationsK.edit),
      copyBlank: t(genericTranslationsK.copyBlank),
      yes: t(genericTranslationsK.yes),
      save: t(genericTranslationsK.save),
      sortDescending: t(genericTranslationsK.sortDescending),
      next: t(genericTranslationsK.next),
      fullView: t(genericTranslationsK.fullView),
    }),
    [i18n.language]
  );
};